import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';

const FooterCredits = ({clang, copy}) => {
    return (
        <div className="footer__credits" dangerouslySetInnerHTML={{__html: copy}}>
        </div>
    );
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
});

export default withRouter(connect(mapStateToProps)(FooterCredits));



// WEBPACK FOOTER //
// ./src/components/footer/FooterCredits.js